import { Injectable } from '@angular/core';
import { EngageUserDetail } from '../../model/engage/user-detail';
import { PricingOption } from '../../model/common/pricing-option';

@Injectable()
export class SharedDataService {
    userDetail: EngageUserDetail;
    pricingOption: PricingOption;
    dealerData: any = null;
}